import React from "react";
//#region types
import { ReportListProps } from "models/propTypes/reportsPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import ReportListItem from "./reportListItem";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ReportList: React.FC<ReportListProps> = (props) => {
  const { reportKey, title, icon, reports, displayType } = props;

  return (
    <Grid container id={reportKey} className={cssExports.reportNavList}>
      <Grid container item className={cssExports.title}>
        {title}
      </Grid>
      {reports && (
        <Grid item container spacing={1}>
          {reports.map((report, index) => (
            <Grid key={report.reportKey} item container>
              <ReportListItem {...report} icon={report.icon ?? icon} displayType={displayType} />
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

export default ReportList;
